import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  return (
    <div className="how-it-works-section">
      <h2 className="how-it-works-title">How it works</h2>
      
      <p className="how-it-works-description">
      Answer just 10 quick questions about your current online setup and get a clear score showing where your restaurant is doing great and where you could be attracting more orders.
      </p>
      
      <p className="how-it-works-details">
      Your online ordering success starts with knowing how you’re performing today. With your answers, we’ll show you exactly how to:
      </p>
      
      <ul className="how-it-works-checklist">
        <li>✓ Reach more hungry customers online</li>
        <li>✓ Turn website visitors into paying orders</li>
        <li>✓ Use your data to boost repeat business</li>
        <li>✓ Make your online presence work harder for you</li>
      </ul>
      
      <p className="how-it-works-more">... and more!</p>
    </div>
  );
};

export default HowItWorks;
